import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import { videoList } from "@/mocks/videos";

interface Slide {
  id: string;
  title: string;
  excerpt: string;
  cover: string;
  badge: string;
  type: string;
}

const slides: Slide[] = [
  {
    id: newsList[0].id,
    title: newsList[0].title,
    excerpt: newsList[0].excerpt,
    cover: newsList[0].cover,
    badge: "热点资讯",
    type: "news",
  },
  {
    id: videoList[0].id,
    title: videoList[0].title,
    excerpt: videoList[0].excerpt,
    cover: videoList[0].cover,
    badge: "推荐视频",
    type: "video",
  },
  {
    id: newsList[1].id,
    title: newsList[1].title,
    excerpt: newsList[1].excerpt,
    cover: newsList[1].cover,
    badge: "影视速递",
    type: "news",
  },
  {
    id: newsList[2].id,
    title: newsList[2].title,
    excerpt: newsList[2].excerpt,
    cover: newsList[2].cover,
    badge: "音乐头条",
    type: "news",
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setActive((prev) => (prev + dir + slides.length) % slides.length);
  };

  return (
    <section className="relative w-full overflow-hidden rounded-xl">
      <div className="relative h-[320px] w-full md:h-[440px]">
        {slides.map((slide, index) => (
          <Link
            key={slide.id}
            to={`/detail/${slide.id}`}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={slide.cover}
              alt={slide.title}
              title={`${slide.title} - 我爱搞`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-foreground-950/10"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 dark:text-foreground-950">
                <i className="ri-fire-line text-sm"></i>
                {slide.badge}
              </span>
              <h2 className="mt-3 max-w-3xl font-heading text-lg font-bold leading-snug text-background-50 md:text-3xl line-clamp-2">
                {slide.title}
              </h2>
              <p className="mt-2 hidden max-w-2xl text-sm text-background-100/90 sm:block md:text-base line-clamp-2">
                {slide.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>

      <button
        type="button"
        onClick={() => go(-1)}
        aria-label="上一张"
        className="absolute left-3 top-1/2 hidden h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/85 text-foreground-800 transition-colors hover:bg-background-50 md:flex"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        onClick={() => go(1)}
        aria-label="下一张"
        className="absolute right-3 top-1/2 hidden h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-50/85 text-foreground-800 transition-colors hover:bg-background-50 md:flex"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-4 right-5 flex items-center gap-1.5 md:bottom-8 md:right-8">
        {slides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第 ${index + 1} 张`}
            onClick={() => setActive(index)}
            className={`h-1.5 cursor-pointer rounded-full transition-all ${
              index === active ? "w-6 bg-primary-400" : "w-1.5 bg-background-50/60"
            }`}
          />
        ))}
      </div>
    </section>
  );
}